module.exports = __webpack_public_path__ + "static/media/29EUNOG10.581bb195.jpg";